import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-virtual-private-cloud',
  templateUrl: './virtual-private-cloud.component.html',
  styleUrls: ['./virtual-private-cloud.component.css']
})
export class VirtualPrivateCloudComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}